import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    meta: { title: "麻城公交" },
    component: () => import('../views/home')
  },
  {
    path: '/product',
    meta: { title: "产品" },
    component: () => import('../views/product')
  },
  {
    path: '/register',
    meta: { title: "注册" },
    component: () => import('../views/register')
  },
  {
    path: '/banner',
    meta: { title: "下载麻城公交" },
    component: () => import('../views/banner')
  },
  {
    path: '/recommend',
    meta: { title: "推荐" },
    component: () => import('../views/recommend')
  },
  {
    path: '/statistics',
    meta: { title: "统计" },
    component: () => import('../views/statistics')
  },
  {
    path: '/survey',
    meta: { title: "服务评价" },
    component: () => import('../views/survey')
  },
  {
    path: '/secret',
    meta: { title: "隐私" },
    component: () => import('../views/secret')
  },
]

const router = new VueRouter({
  routes
})

export default router
